import { Tools } from "@carbon/pictograms-react";
import { ServerOperatingSystems } from '@carbon/pictograms-react';
import * as React from 'react';
export default {
  Tools,
  ServerOperatingSystems,
  React
};